import { createSelector } from '@reduxjs/toolkit';

const selectTrailerDetails = state => state.trailerDetails;

export const selectSelectedTrailer = createSelector(selectTrailerDetails, state => state?.trailer?.item ?? {});
